import React from 'react';
import PropTypes from 'prop-types';
import styles from './ButtonArrow.scss'

const ButtonArrow = props => {

	const classes = [];
	classes.push(styles.button)
	if (props.bigger) {
		classes.push(styles.bigger)
	}
	return (
		<button
			type={props.type}
			className={classes.join(' ')}
			onClick={props.onClick}
			id={props.id}>
			<div/>
		</button>
	);
};

ButtonArrow.defaultProps = {
	bigger: false,
	type: 'button'
}

ButtonArrow.propTypes = {
	onClick: PropTypes.func,
	id: PropTypes.string,
	bigger: PropTypes.bool,
	type: PropTypes.oneOf(["submit", "reset", "button"])
};

export default ButtonArrow;